import { $api } from "../../../../../services/request.config";
import { getActiveRequestsDelegationsActions } from "../getActiveRequestsDelegations.actions";
// const data = [
//     {
//         "id": 0,
//         "initiator": {
//             "pid": 0,
//             "tabNumber": "string",
//             "fullName": "string",
//             "jobTitle": "string",
//             "fullStructName": "string",
//         },
//         "delegate": {
//             "pid": 0,
//             "tabNumber": "string",
//             "fullName": "string",
//             "jobTitle": "string",
//             "fullStructName": "string",
//         },
//         "applicationsTypesId": [
//             0,
//         ],
//         "from": "2025-10-29",
//         "to": "2025-10-29",
//     },
// ];
// [
//     {
//         "id": 0,
//         "from": "2025-10-31",
//         "to": "2025-10-31",
//         "delegator": {
//             "pid": 0,
//             "fullName": "string",
//             "tabNumber": "string",
//             "jobTitle": "string",
//             "fullStructName": "string",
//         },
//         "delegat": {
//             "pid": 0,
//             "fullName": "string",
//             "tabNumber": "string",
//             "jobTitle": "string",
//             "fullStructName": "string",
//         },
//         "requestTypes": [
//             {
//                 "id": 0,
//                 "name": "string",
//                 "categoryId": 0,
//             },
//         ],
//     },
// ]
export const getActiveRequestDelegations = (props) => async(dispatch) => {
    try {
        let response;
        // const response = await $api("v1/manager/delegations");
        if(props && props.option && props.option === "initiator") {
            response = await $api("v1/manager/delegations/as-initiator");
        } else {
            response = await $api("v1/manager/delegations/as-delegate");
        }

        if(response.status === 200) {

            //response.data
            dispatch(getActiveRequestsDelegationsActions(
                response.data
            ));
        }
    } catch (e) {
        // console.log(e);
        dispatch(getActiveRequestsDelegationsActions([]));

    }
};
